import { render, staticRenderFns } from "./CollectionMian.vue?vue&type=template&id=3adae351&scoped=true"
import script from "./CollectionMian.vue?vue&type=script&lang=js"
export * from "./CollectionMian.vue?vue&type=script&lang=js"
import style0 from "./CollectionMian.vue?vue&type=style&index=0&id=3adae351&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adae351",
  null
  
)

export default component.exports